import { ProfileRole } from '../auth/constants'

export const ROLE_PATH_MAPPERS = {
	[ProfileRole.Admin]: '/admin',
	[ProfileRole.Operator]: '/operator',
}
